import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);

export const http = Vue.axios;


// WEBPACK FOOTER //
// ./src/axios.js